import React from "react";
import { Link } from "gatsby";

function CtaBanner({
  title = "Want to learn more?",
  subtitle = "Sometimes it's easier to just talk!",
  ctaText = "Get in touch",
  ctaIconEnabled = true,
  ctaIcon = "fa-solid fa-arrow-right",
  urlInternal = "/contact",
  urlExternal = "",
  bgClass = "bg-gradient-to-r from-rhoBlueDark-700 to-rhoBlueDark-600",
  btnClass = "text-rhoBlueDark-700 bg-rhoLime-700 hover:bg-rhoLime-400",
}) {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pb-12 md:pb-20">
          {/* CTA box */}
          <div
            className={`rounded py-10 px-8 md:py-16 md:px-12 shadow-2xl ${bgClass}`}
            data-aos="zoom-y-out"
          >
            <div className="flex flex-col lg:flex-row justify-between items-center">
              {/* CTA content */}
              <div className="mb-6 lg:mr-16 lg:mb-0 text-center lg:text-left">
                {title && <h3 className="h3 text-white mb-2">{title}</h3>}
                {subtitle && (
                  <p className="text-rhoOffWhite-100 text-lg">{subtitle}</p>
                )}
              </div>

              {/* CTA button */}
              <div>
                {urlInternal && (
                  <Link
                    className={`btn group h4 w-full mb-4 sm:w-full sm:mb-0 ${btnClass}`}
                    to={urlInternal}
                  >
                    {ctaText}
                    {ctaIconEnabled && (
                      <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-4">
                        &nbsp;<i className={ctaIcon}></i>
                      </span>
                    )}
                  </Link>
                )}
                {urlExternal && (
                  <a
                    className={`btn group h4 w-full mb-4 sm:w-full sm:mb-0 ${btnClass}`}
                    href={urlExternal}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {ctaText}
                    {ctaIconEnabled && (
                      <span className="inline-block transform transition-transform duration-300 group-hover:translate-x-4">
                        &nbsp;<i className={ctaIcon}></i>
                      </span>
                    )}
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CtaBanner;
